import React, { useContext, Fragment } from 'react';
import DataContext from '../../data/DataContext';
import { withStyles, Divider } from '@material-ui/core';
import Carousel from '../../carousel/Carousel';

// import IconControl from "../../../asset/img/img_cm_control.png";
// import IconEvent from "../../../asset/img/img_cm_event.png";
// import IconInstall from "../../../asset/img/img_cm_installation.png";
// import IconLocation from "../../../asset/img/img_cm_location.png";
// import IconPurchase from "../../../asset/img/img_cm_purchase.png";
// import IconReservation from "../../../asset/img/img_cm_reservation.png";
// import IconSearch from "../../../asset/img/img_cm_search.png";
// import IconSolution from "../../../asset/img/img_cm_solution_method.png";
// import IconCleaning from "../../../asset/img/ic_shortcut_homecare.png";
// import IconStory from "../../../asset/img/ic_cm_story.svg";
// import IconCare from "../../../asset/img/img_cm_caresolution.png";

import IconExpandables from '../../../asset/img/helpcard_expendables.svg';
import IconInstall from '../../../asset/img/helpcard_install.svg';
import IconRecommend from '../../../asset/img/helpcard_recommend.svg';
import IconRental from '../../../asset/img/helpcard_rental.svg';
import IconRepair from '../../../asset/img/helpcard_repair.svg';
import IconReservation from '../../../asset/img/helpcard_reservation.svg';
import IconSearch from '../../../asset/img/helpcard_search.svg';
import IconShopping from '../../../asset/img/helpcard_shopping.svg';
import IconWash from '../../../asset/img/helpcard_wash.svg';

const helpTypeIconMap = {
  helpSelfRepair: IconRepair,
  helpFindProduct: IconSearch,
  helpBuyConsumables: IconExpandables,
  helpCheckReserve: IconReservation,
  helpReserveInstall: IconInstall,
  helpPurchaseCounsel: IconShopping,
  helpCleaningService: IconWash,
  helpRecommend: IconRecommend,
  helpCareSolution: IconRental,

  // helpReserveEng: IconControl,
  // helpFindCenter: IconLocation,
  // helpEvent: IconEvent,
  // helpDeviceControl: IconControl,
  // helpStory: IconStory,
};

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.5px',
    margin: '6px 0px',
    zIndex: 10,
  },
  carousel: {
    width: '100%',
    height: '144px',
  },
  listitem: {
    width: '16.563',
    padding: '0px 8px 0px 0px',
    marginBottom: '8px',
  },
  card: {
    width: '16.25rem',
    marginRight: '5px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    background: theme.color.button.background_white,
    borderRadius: '6px',
    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.1)',
    position: 'relative',
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    // alignItems: "center",
    flexGrow: 1,
    textAlign: 'center',
    background: '#fff',
    // border: "1px solid #e1e1e1",
    borderRadius: '6px 6px 0px 0px',
    padding: '0px 20px',
  },
  thumbnail: {
    width: '48px',
    height: '48px',
    margin: '16px 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.color.background,
    borderRadius: '50%',
  },
  thumbnailImage: {
    width: '5.625rem',
    height: '4.375rem',
  },
  info: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'start',
    margin: '15.5px 0px 16px 0',
    overflow: 'hidden',
  },
  infoDescription: {
    fontSize: theme.font.size14,
    fontWeight: 'normal',
    color: '#666',
    textAlign: 'left',
    overflow: 'hidden',
    wordBreak: 'keep-all',
  },
  sampleUtterances: {
    margin: '0 0 15.5px 0',
    color: theme.color.text_color.black,
    fontSize: theme.font.size15,
    fontWeight: 'bold',
    lineHeight: '1.47',
    textAlign: 'left',
  },
  buttonBox: {
    background: '#fff',
    width: '100%',
    padding: '0 20px',
    marginBottom: '16px',
    borderRadius: '0 0 6px 6px',
    // border: "1px solid #e1e1e1",
  },
  externalButton: {
    width: '100%',
    // minHeight: "3.5rem",
    // maxHeight: "4.5rem",
    height: '40px',
    color: theme.color.button.text_white, // "#00a0b6",
    fontWeight: 'bold',
    fontSize: theme.font.size14,
    border: '0',
    borderRadius: '6px',
    // borderTop: "none",
    padding: 0,
    background: theme.color.button.background_red,
    // "&:active": {
    //   background: "rgba(38, 38, 38, 0.1)",
    // },
    // outline: "0 none",
    // whiteSpace: "normal",
    lineHeight: 1.43,
    margin: '3px 0',
  },
  externalDivider: {
    width: '100%',
    height: '1px',
    background: '#eee',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '38px',
  },
  buttonText: {},
});

const Card = React.forwardRef((props, ref) => {
  const { classes, data } = props;
  const context = useContext(DataContext);

  const handleClick = (helpSpeech) => {
    if (ref.clickAllowed()) {
      context.request(context, helpSpeech, 'button');
    }
  };

  return data.list_items.map((item, index) => (
    // return list_items.map((item, index) => (
    <div className={classes.listitem} key={`helpcard-${index}`}>
      <div className={classes.card} role={'button'}>
        <div
          className={classes.content}
          tabIndex={0}
          aria-label={`${item.title}, ${item.description}, ${item.sample_utterances}, ${
            index + 1
          } / ${data.list_items.length}`}
        >
          <div className={classes.thumbnail}>
            <div
              // className={classes.thumbnailImage}
              style={{
                minWidth: '32px',
                height: '32px',
                // backgroundSize: "90px 70px",
                backgroundImage: `url(${helpTypeIconMap[item.thumbnail_code]})`,
              }}
            />
          </div>
          <div className={classes.sampleUtterances}>
            {item.sample_utterances.map((value, key) => {
              return (
                <Fragment key={key}>
                  {value}
                  <br />
                </Fragment>
              );
            })}
          </div>
          <Divider orientation={'horizontal'} className={classes.externalDivider} />
          <div className={classes.info}>
            <div className={classes.infoDescription}>
              {item.description.split('\n').map((value, key) => {
                return (
                  <Fragment key={key}>
                    {value}
                    <br />
                  </Fragment>
                );
              })}
            </div>
          </div>
        </div>

        <div className={classes.buttonBox}>
          {item.buttons.map((button, index) => (
            <button
              type="button"
              className={classes.externalButton}
              disabled={context.conversationEnd}
              key={index}
              onClick={() => handleClick(button.speech)}
            >
              {button.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  ));
});

function HELPCARD(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  return (
    <>
      <div className={classes.root}>
        <Carousel
          className={classes.carousel}
          component={withStyles(styles)(Card)}
          data={data}
          ariaLabel={context.string.aria.help}
        />
      </div>
    </>
  );
}
export default withStyles(styles)(HELPCARD);
